import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { SiteHeader } from "../../components/header/header";
import "../../styles/home-page.css";
import { SlideAnim } from "../../components/animations/appear";
import { projectData } from "../../_helpers/project-data";
import { ProjectUnit } from "../../components/cards/project-unit";

import { WhyUs } from "../../components/cards/why-us";
import { HowItWorks } from "../../components/cards/how-it-works";


export const HomePage = () => {

    const serviceRef = useRef();
    const state = useLocation().state;
    const navigateTo = useNavigate();

    useEffect(() => {
        if (state === "service") {
            serviceRef.current.scrollIntoView({ behavior: 'smooth' });
        }
    },[state])

    return (
        <div className="page-body flx-col">
            <SiteHeader 
                title={"Shnellentrümpelung"}
                navAction={() => {
                    serviceRef.current.scrollIntoView({ behavior: 'smooth' });
                }} 
            />
            <div className="flx-col app-body">
                <div className="overlay-box">
                    <SlideAnim>
                        <h1>Schnell Entrümpelung & Umzüge</h1>
                        <h1>Berlin-Brandenburg</h1>
                        <div className="lg-txt">
                            24 Stunden erreichbar – 7 Tage die Woche
                        </div>
                    </SlideAnim>
                </div>
                <div className="customer-reasons flx-rw ">
                    <WhyUs />
                    <HowItWorks />
                </div>
                <div className="projects-done" id="services" ref={serviceRef}>
                    <div className="reason-cap">
                        <div className="reason-txt blk">Unsere</div>
                        <div className="reason-txt sec-col">Leistungen</div>
                    </div>
                    <div className="cap-sub-txt">
                        Von der einfachen Entrümpelung bis zur kompletten Haushaltsauflösung – wir sind Ihr Partner in Berlin
                    </div>
                    <div className="project-box flx-rw">
                        {projectData.map((data) => {
                            return (
                                <ProjectUnit
                                    project={data.project}
                                    imageUrl={data.imageUrl}
                                    description={data.description}
                                    pointsArray={data.pointsArray}
                                />
                            )
                        })}
                    </div>
                    <div className="action-buttons flx-rw c-al c-jt">
                        <button 
                            className="action-button prim sh-bx"
                            onClick={() => navigateTo("/contact")}
                        >
                            Kostenloses Angebot Anforden
                        </button>
                    </div>
                </div>

            </div>
        </div>
    )
}